module.exports = __webpack_public_path__ + "media/images/ComparationTable-de60acdc3dd2e5bee67b577edf71679d.jpg";